
import React, { useState, useEffect, useMemo  } from 'react';
import Navbar from '../Navbar';
import Footer from '../Footer';
import { getDatabase, ref, push, set } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import { MdEmail } from "react-icons/md";
import { auth } from '../firebase';
import { uploadBytes, getDownloadURL, getStorage, ref as storageRef } from 'firebase/storage';
import { get } from 'firebase/database';
import Select from 'react-select'
import countryList from 'react-select-country-list'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useTranslation } from 'react-i18next';


function CreateBracket() {
  const CreateBracketsRef = ref(getDatabase(), 'CreateBracket');
  const [captainsName, setCaptainsName] = useState('');
  const [nameOfBracket, setNameOfBracket] = useState('');
  const [tournament, setTournament] = useState('English Premier League');
  const { t } = useTranslation();

  const [description, setDescription] = useState('');
  const [location, setLocation] = useState('');
  const [maxAmountOfPlayers, setMaxAmountOfPlayers] = useState(20);
  const [purpose, setPurpose] = useState('');
  const [sent, setSent] = useState(false);
  const [image, setImage] = useState(''); // State variable to store image file
  const [imageUrl, setImageUrl] = useState(''); // State variable to store image URL
  const [error, setError] = useState(false)
  const storage = getStorage(auth.app);
  const [isPublic, setIsPublic] = useState(true);
  const [participantsCount, setParticipantsCount] = useState(1);
  const [value, setValue] = useState('')
  const options = useMemo(() => countryList().getData().map(country => ({ value: country.label, label: country.label })), []);
  const navigate = useNavigate();
  const prohibited = ['banned', "ahole", "anus", "ash0le", "ash0les", "asholes", "ass", "Ass Monkey", "Assface", "assh0le", "assh0lez", "asshole", "assholes", "assholz", "asswipe", "azzhole", "bassterds", "bastard", "bastards", "bastardz", "basterds", "basterdz", "Biatch", "bitch", "bitches", "Blow Job", "boffing", "butthole", "buttwipe", "c0ck", "c0cks", "c0k", "Carpet Muncher", "cawk", "cawks", "Clit", "cnts", "cntz", "cock", "cockhead", "cock-head", "cocks", "CockSucker", "cock-sucker", "crap", "cum", "cunt", "cunts", "cuntz", "dick", "dild0", "dild0s", "dildo", "dildos", "dilld0", "dilld0s", "dominatricks", "dominatrics", "dominatrix", "dyke", "enema", "f u c k", "f u c k e r", "fag", "fag1t", "faget", "fagg1t", "faggit", "faggot", "fagg0t", "fagit", "fags", "fagz", "faig", "faigs", "fart", "flipping the bird", "fuck", "fucker", "fuckin", "fucking", "fucks", "Fudge Packer", "fuk", "Fukah", "Fuken", "fuker", "Fukin", "Fukk", "Fukkah", "Fukken", "Fukker", "Fukkin", "g00k", "God-damned", "h00r", "h0ar", "h0re", "hells", "hoar", "hoor", "hoore", "jackoff", "jap", "japs", "jerk-off", "jisim", "jiss", "jizm", "jizz", "knob", "knobs", "knobz", "kunt", "kunts", "kuntz", "Lezzian", "Lipshits", "Lipshitz", "masochist", "masokist", "massterbait", "masstrbait", "masstrbate", "masterbaiter", "masterbate", "masterbates", "Motha Fucker", "Motha Fuker", "Motha Fukkah", "Motha Fukker", "Mother Fucker", "Mother Fukah", "Mother Fuker", "Mother Fukkah", "Mother Fukker", "mother-fucker", "Mutha Fucker", "Mutha Fukah", "Mutha Fuker", "Mutha Fukkah", "Mutha Fukker", "n1gr", "nastt", "nigger;", "nigur;", "niiger;", "niigr;", "orafis", "orgasim;", "orgasm", "orgasum", "oriface", "orifice", "orifiss", "packi", "packie", "packy", "paki", "pakie", "paky", "pecker", "peeenus", "peeenusss", "peenus", "peinus", "pen1s", "penas", "penis", "penis-breath", "penus", "penuus", "Phuc", "Phuck", "Phuk", "Phuker", "Phukker", "polac", "polack", "polak", "Poonani", "pr1c", "pr1ck", "pr1k", "pusse", "pussee", "pussy", "puuke", "puuker", "qweir", "recktum", "rectum", "retard", "sadist", "scank", "schlong", "screwing", "semen", "sex", "sexy", "Sh!t", "sh1t", "sh1ter", "sh1ts", "sh1tter", "sh1tz", "shit", "shits", "shitter", "Shitty", "Shity", "shitz", "Shyt", "Shyte", "Shytty", "Shyty", "skanck", "skank", "skankee", "skankey", "skanks", "Skanky", "slag", "slut", "sluts", "Slutty", "slutz", "son-of-a-bitch", "tit", "turd", "va1jina", "vag1na", "vagiina", "vagina", "vaj1na", "vajina", "vullva", "vulva", "w0p", "wh00r", "wh0re", "whore", "xrated", "xxx", "b!+ch", "bitch", "blowjob", "clit", "arschloch", "fuck", "shit", "ass", "asshole", "b!tch", "b17ch", "b1tch", "bastard", "bi+ch", "boiolas", "buceta", "c0ck", "cawk", "chink", "cipa", "clits", "cock", "cum", "cunt", "dildo", "dirsa", "ejakulate", "fatass", "fcuk", "fuk", "fux0r", "hoer", "hore", "jism", "kawk", "l3itch", "l3i+ch", "masturbate", "masterbat*", "masterbat3", "motherfucker", "s.o.b.", "mofo", "nazi", "nigga", "nigger", "nutsack", "phuck", "pimpis", "pusse", "pussy", "scrotum", "sh!t", "shemale", "shi+", "sh!+", "slut", "smut", "teets", "tits", "boobs", "b00bs", "teez", "testical", "testicle", "titt", "w00se", "jackoff", "wank", "whoar", "whore", "*damn", "*dyke", "*fuck*", "*shit*", "@$$", "amcik", "andskota", "arse*", "assrammer", "ayir", "bi7ch", "bitch*", "bollock*", "breasts", "butt-pirate", "cabron" ]
  const notify = (message) => {
    toast.error(message, {
      // autoClose: 5000,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Ensure user is logged in
    if (!auth.currentUser) {
      alert('You must be logged in to create a Huddle.');
      return;
    }
    const descriptionLowerCase = description.toLowerCase();
    const nameLowerCase = nameOfBracket.toLowerCase();
    const captainsNameLowerCase = captainsName.toLowerCase();
    const purposeLowerCase = purpose.toLowerCase();


    for (const word of prohibited) {
      if (descriptionLowerCase.includes(word.toLowerCase())   )  {
        setError('');
        // alert('please do not use prohibited words')
        notify('Huddle Description cannot contain prohibited words!')
        return; // Return early and prevent submission
      }
    }

    for (const word of prohibited) {
      if (nameLowerCase.includes(word.toLowerCase())  )  {
        setError('');
        // alert('please do not use prohibited words')
        notify('Name of Huddle cannot contain prohibited words!')
        return; // Return early and prevent submission
      }
    }
    for (const word of prohibited) {
      if (purposeLowerCase.includes(word.toLowerCase())  )  {
        setError('');
        // alert('please do not use prohibited words')
        notify('Purpose of Huddle cannot contain prohibited words!')
        return; // Return early and prevent submission
      }
    }
    for (const word of prohibited) {
      if (captainsNameLowerCase.includes(word.toLowerCase())  )  {
        setError('');
        // alert('please do not use prohibited words')
        notify('Captains Name cannot contain prohibited words!')
        return; // Return early and prevent submission
      }
    }

    // Ensure required fields are filled
    if (!nameOfBracket || !captainsName || !description || !location || !maxAmountOfPlayers || !purpose  ) {
      alert('Please fill in all of the required fields! please visit ');
      return;
    }
  
    // Check if the bracket name already exists
    const snapshot = await get(CreateBracketsRef);
    const brackets = [];
    snapshot.forEach((childSnapshot) => {
      const bracket = childSnapshot.val();
      brackets.push(bracket.nameOfBracket);
    });
  
    if (brackets.includes(nameOfBracket)) {
      setError('A Huddle with the same name already exists. Please choose a different name.');
      return;
    }
  
    try {
      // Upload image to Firebase Storage
      const imageRef = storageRef(storage, `BracketImages/${image.name}`);
      await uploadBytes(imageRef, image);
  
      // Get the download URL of the uploaded image
      const downloadURL = await getDownloadURL(imageRef);
      setImageUrl(downloadURL);
  

      const user = auth.currentUser;
      const userDisplayName = user.displayName;
      const userEmail = user.email;
      const userId = user.uid;

      // Create a new bracket object with image URL
      const bracketData = {
        nameOfBracket,
        image: downloadURL,
        captainsName,
        tournament,
        description,
        location,
        maxAmountOfPlayers,
        purpose,
        isPublic,
        participants: {
          [auth.currentUser.uid]: {
              displayName: userDisplayName,
              email: userEmail
          }
      },
        participantsCount: 1, // Initialize participantsCount with 1
        timestamp: new Date().toISOString(),
        userId: auth.currentUser.uid
      };
  
      // Push the new bracket to the 'CreateBracket' reference
      const newBracketRef = push(CreateBracketsRef);
      await set(newBracketRef, bracketData);
  
      // Clear input fields after submission
      setNameOfBracket('');
      setCaptainsName('');
      setDescription('');
      setTournament('')
      setLocation('');
      setMaxAmountOfPlayers('');
      setPurpose('');
      setImage('');
      setParticipantsCount(1);
      setSent(true);
    } catch (error) {
      console.error('Error creating a Huddle:', error);
      alert('Error creating Huddle.');
    }
    setTimeout(() => {
      navigate('/dashboard');
    }, 3000)  };
  
  
  const changeHandler = value => {
    setValue(value)
  }


  return (
    <div>
      <Navbar />
      <div className='App-headerV8 '>
      <section className=" py-3 py-md-5">
        <div className="container">
          <div className="row justify-content-md-center">
            <div className="col-12 col-md-10 col-lg-8 col-xl-7 col-xxl-6">
            <h2 className="mb-4 display-5 text-center text-light" style={{ fontFamily: 'Lato, sans-serif'}}>{t('create_huddle_title')}</h2>
<p className=" mb-5 text-center text-light "style={{ fontFamily: 'Lato, sans-serif', fontWeight: '300' }}>{t('create_huddle_description')}</p>

              <hr className="w-50 mx-auto mb-5 mb-xl-9 border-dark-subtle" />
            </div>
          </div>
        </div>
        <div className="container ">
          <div className="row justify-content-lg-center">
            <div className="col-12 col-lg-9">
              <div className="bg-white border rounded shadow-sm overflow-hidden " >

                <form action="#!" onSubmit={handleSubmit}>
                  <div className="row gy-4 gy-xl-5 p-4 p-xl-5 ">
                    <div className="col-12 col-md-12">
                      <label htmlFor="nameOfBracket" className="form-label"> Name Of Huddle <span className="text-danger"></span></label>
                      <input
  type="text"
  className={`form-control ${error && 'input-error'}`}
  id="nameOfBracket"
  name="nameOfBracket"
  placeholder="Max 25 Characters"
  value={nameOfBracket}
  onChange={(e) => setNameOfBracket(e.target.value)}
  maxLength={25}
  required
/>
                    </div>
                    
                    <div className="col-12 col-md-6">
  <label htmlFor="tournament" className="form-label">
    Tournament
  </label>
  <div className="input-group">
    <span className="input-group-text">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-trophy"
        viewBox="0 0 16 16"
      >
        <path d="M2.5.5A.5.5 0 0 1 3 0h10a.5.5 0 0 1 .5.5q0 .807-.034 1.536a3 3 0 1 1-1.133 5.89c-.79 1.865-1.878 2.777-2.833 3.011v2.173l1.425.356c.194.048.377.135.537.255L13.3 15.1a.5.5 0 0 1-.3.9H3a.5.5 0 0 1-.3-.9l1.838-1.379c.16-.12.343-.207.537-.255L6.5 13.11v-2.173c-.955-.234-2.043-1.146-2.833-3.012a3 3 0 1 1-1.132-5.89A33 33 0 0 1 2.5.5m.099 2.54a2 2 0 0 0 .72 3.935c-.333-1.05-.588-2.346-.72-3.935m10.083 3.935a2 2 0 0 0 .72-3.935c-.133 1.59-.388 2.885-.72 3.935M3.504 1q.01.775.056 1.469c.13 2.028.457 3.546.87 4.667C5.294 9.48 6.484 10 7 10a.5.5 0 0 1 .5.5v2.61a1 1 0 0 1-.757.97l-1.426.356a.5.5 0 0 0-.179.085L4.5 15h7l-.638-.479a.5.5 0 0 0-.18-.085l-1.425-.356a1 1 0 0 1-.757-.97V10.5A.5.5 0 0 1 9 10c.516 0 1.706-.52 2.57-2.864.413-1.12.74-2.64.87-4.667q.045-.694.056-1.469z"/>
      </svg>
    </span>
    <select
      className="form-select"
      id="tournament"
      name="tournament"
      value={tournament}
      onChange={(e) => setTournament(e.target.value)}
      required
    >
      {/* <option value="EURO 2024">EURO 2024</option> */}
      <option value="English Premier League">English Premier League</option>
      <option value="Scottish Premiership">Scottish Premiership</option>
      <option value="Championship">Championship</option>
      <option value="La Liga">La Liga</option>
      <option value="UCL">UCL</option>
      <option value="Bundesliga">Bundesliga</option>
      <option value="Serie A">Serie A</option>
      <option value="SASoccer">Premier Soccer League</option>





   


    </select>
  </div>
</div>


                    <div className="col-12 col-md-6">
                      <label htmlFor="captainsName" className="form-label">Captain's Name </label>
                      <div className="input-group">
                        <span className="input-group-text">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-person-arms-up" viewBox="0 0 16 16">
  <path d="M8 3a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"/>
  <path d="m5.93 6.704-.846 8.451a.768.768 0 0 0 1.523.203l.81-4.865a.59.59 0 0 1 1.165 0l.81 4.865a.768.768 0 0 0 1.523-.203l-.845-8.451A1.5 1.5 0 0 1 10.5 5.5L13 2.284a.796.796 0 0 0-1.239-.998L9.634 3.84a.7.7 0 0 1-.33.235c-.23.074-.665.176-1.304.176-.64 0-1.074-.102-1.305-.176a.7.7 0 0 1-.329-.235L4.239 1.286a.796.796 0 0 0-1.24.998l2.5 3.216c.317.316.475.758.43 1.204Z"/>
</svg>
                        </span>
                        <input type="text" className="form-control" id="captainsname" name="captainsname" value={captainsName}onChange={(e) => setCaptainsName(e.target.value)} maxLength={15} required />
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
              <label htmlFor="bracketImage" className="form-label">Huddle Image</label>
              <input type="file" className="form-control" id="bracketImage" accept="image/*" onChange={(e) => setImage(e.target.files[0])} />
            </div>
            
          
                    <div className="col-12 col-md-6">
                      <label htmlFor="MaxAmountOfPlayers" className="form-label">Max Amount Of Players</label>
                      
                      <div className="input-group">
                        <span className="input-group-text">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fillRule="currentColor" className="bi bi-diagram-3" viewBox="0 0 16 16">
  <path fillRule="evenodd" d="M6 3.5A1.5 1.5 0 0 1 7.5 2h1A1.5 1.5 0 0 1 10 3.5v1A1.5 1.5 0 0 1 8.5 6v1H14a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0V8h-5v.5a.5.5 0 0 1-1 0v-1A.5.5 0 0 1 2 7h5.5V6A1.5 1.5 0 0 1 6 4.5zM8.5 5a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5zM0 11.5A1.5 1.5 0 0 1 1.5 10h1A1.5 1.5 0 0 1 4 11.5v1A1.5 1.5 0 0 1 2.5 14h-1A1.5 1.5 0 0 1 0 12.5zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm4.5.5A1.5 1.5 0 0 1 7.5 10h1a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 8.5 14h-1A1.5 1.5 0 0 1 6 12.5zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5zm4.5.5a1.5 1.5 0 0 1 1.5-1.5h1a1.5 1.5 0 0 1 1.5 1.5v1a1.5 1.5 0 0 1-1.5 1.5h-1a1.5 1.5 0 0 1-1.5-1.5zm1.5-.5a.5.5 0 0 0-.5.5v1a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-1a.5.5 0 0 0-.5-.5z"/>
</svg>
                        </span>
                        <input type="text" className="form-control" id="MaxAmountOfPlayers" name="MaxAmountOfPlayers" maxLength={5}  value={maxAmountOfPlayers} onChange={(e) => setMaxAmountOfPlayers(e.target.value)} required disabled/>
                      </div>
                      <i>* If you are interested in expanding the huddle size please contact us</i>

                    </div>


                    <div className="col-12 col-md-6">
                      <label htmlFor="location" className="form-label">Country</label>
                      <div className="input-group">
                        <span className="input-group-text">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-pin-map" viewBox="0 0 16 16">
  <path fillRule="evenodd" d="M3.1 11.2a.5.5 0 0 1 .4-.2H6a.5.5 0 0 1 0 1H3.75L1.5 15h13l-2.25-3H10a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 .4.2l3 4a.5.5 0 0 1-.4.8H.5a.5.5 0 0 1-.4-.8z"/>
  <path fillRule="evenodd" d="M8 1a3 3 0 1 0 0 6 3 3 0 0 0 0-6M4 4a4 4 0 1 1 4.5 3.969V13.5a.5.5 0 0 1-1 0V7.97A4 4 0 0 1 4 3.999z"/>
</svg>
                        </span>
                        <Select type="text" className="form-control" id="location" name="location" options={options}  value={{ value: location, label: location }}
   onChange={(selectedOption) => setLocation(selectedOption.value)}
   required />
                      </div>
                    </div>
                    <div className="col-12 col-md-6">
  <label htmlFor="Purpose" className="form-label">Purpose</label>
  <div className="input-group">
    <button
      type="button"
      className="input-group-text"
      data-bs-toggle="modal"
      data-bs-target="#purposeModal"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-patch-question"
        viewBox="0 0 16 16"
      >
        <path d="M8.05 9.6c.336 0 .504-.24.554-.627.04-.534.198-.815.847-1.26.673-.475 1.049-1.09 1.049-1.986 0-1.325-.92-2.227-2.262-2.227-1.02 0-1.792.492-2.1 1.29A1.7 1.7 0 0 0 6 5.48c0 .393.203.64.545.64.272 0 .455-.147.564-.51.158-.592.525-.915 1.074-.915.61 0 1.03.446 1.03 1.084 0 .563-.208.885-.822 1.325-.619.433-.926.914-.926 1.64v.111c0 .428.208.745.585.745"/>
        <path d="m10.273 2.513-.921-.944.715-.698.622.637.89-.011a2.89 2.89 0 0 1 2.924 2.924l-.01.89.636.622a2.89 2.89 0 0 1 0 4.134l-.637.622.011.89a2.89 2.89 0 0 1-2.924 2.924l-.89-.01-.622.636a2.89 2.89 0 0 1-4.134 0l-.622-.637-.89.011a2.89 2.89 0 0 1-2.924-2.924l.01-.89-.636-.622a2.89 2.89 0 0 1 0-4.134l.637-.622-.011-.89a2.89 2.89 0 0 1 2.924-2.924l.89.01.622-.636a2.89 2.89 0 0 1 4.134 0l-.715.698a1.89 1.89 0 0 0-2.704 0l-.92.944-1.32-.016a1.89 1.89 0 0 0-1.911 1.912l.016 1.318-.944.921a1.89 1.89 0 0 0 0 2.704l.944.92-.016 1.32a1.89 1.89 0 0 0 1.912 1.911l1.318-.016.921.944a1.89 1.89 0 0 0 2.704 0l.92-.944 1.32.016a1.89 1.89 0 0 0 1.911-1.912l-.016-1.318.944-.921a1.89 1.89 0 0 0 0-2.704l-.944-.92.016-1.32a1.89 1.89 0 0 0-1.912-1.911z"/>
        <path d="M7.001 11a1 1 0 1 1 2 0 1 1 0 0 1-2 0"/>
      </svg>
    </button>
    <input
      type="text"
      className="form-control"
      id="Purpose"
      name="Purpose"
      maxLength={20}
      value={purpose}
      onChange={(e) => setPurpose(e.target.value)}
      required
    />
  </div>
</div>
{/* Modal */}
<div
  className="modal fade"
  id="purposeModal"
  tabIndex="-1"
  aria-labelledby="purposeModalLabel"
  aria-hidden="true"
>
  <div className="modal-dialog">
    <div className="modal-content">
      <div className="modal-header">
        <h5 className="modal-title" id="purposeModalLabel">Purpose Information</h5>
        <button
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div className="modal-body">
        <p>
          Here you can enter the purpose of your huddle. For example:
        </p>
        <ul>
          <li>Just for fun</li>
          <li>Friends & Family</li>
          <li>Workplace Event</li>
          <li>Sports Team</li>
        </ul>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-secondary"
          data-bs-dismiss="modal"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>

                    <div className="col-12">
                      <label htmlFor="message" className="form-label">Description</label>
                      <textarea className="form-control" id="message" name="message" rows="3" maxLength={500} value={description}onChange={(e) => setDescription(e.target.value)} required></textarea>
                    </div>
                    <div>
                    <div className="col-12 col-md-12">
                        <label htmlFor="customSwitch1" className="form-label">Is this Huddle Public? </label>
                        <div className="form-check form-switch">
                          <input className="form-check-input" type="checkbox" id="customSwitch1"  checked={isPublic} onChange={() => setIsPublic(!isPublic)} />
                          <label className="form-check-label" htmlFor="customSwitch1">Public</label>
                        </div>
                      </div>
         
                    </div>
                    <div className="col-10 mx-auto">
                    {sent && (
                  <div className="alert alert-success text-center " role="alert">
                    Huddle created successfully!
                  </div>
                )}
                         {error && (
                  <div className="alert alert-danger text-center " role="alert">
                    Name of Huddle already exists!
                  </div>
                )}
                <ToastContainer />
                      <div className="d-grid">
                        <button className="btn btn-purple btn-lg" type="submit">{t('create_huddle')}</button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
      </div>

 

      <Footer />
    </div>
  );
}

export default CreateBracket;
